import type { IconData } from '@stacksjs/iconify-core'

export const dashboardGauge2: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M9.854 32A15 15 0 0 1 9 27c0-8.284 6.716-15 15-15s15 6.716 15 15c0 1.753-.3 3.436-.853 5\"/><path d=\"M34 38h6.078c1.215 0 2.397-.539 2.945-1.623C44.342 33.769 45 30.105 45 27c0-11.598-9.402-21-21-21S3 15.402 3 27c0 3.105.659 6.77 1.977 9.377C5.525 37.46 6.707 38 7.923 38H14\"/><path d=\"M20.136 34.965a4 4 0 1 0 7.728 2.07a4 4 0 1 0-7.728-2.07m4.899-2.829l3.623-13.523\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default dashboardGauge2
